<template>
  <div>
    <div class="">
      <b-tabs lazy fill justified :value="activeTab" @activate-tab="changeTab">
        <b-tab title="Thiết bị">
          <ListDevices />
        </b-tab>
        <b-tab title="Thiết bị Tingbox">
          <ListDeviceTingBox />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
  import ListDevices from './ListDevices.vue'
  import ListDeviceTingBox from './listTingbox.vue'

  export default {
    name: 'STICKER_STANDEE',

    computed: {
      activeTab() {
        // Lấy giá trị tab từ URL query, mặc định là 0 (tab đầu tiên)
        return parseInt(this.$route.query.tab) || 0
      },
    },

    methods: {
      changeTab(tab) {
        this.$router.push({ query: { tab: tab } })
      },
    },

    // Xử lý khi component được tạo
    mounted() {
      // Nếu không có tab trong URL, set mặc định tab đầu tiên
      if (!this.$route.query.tab) {
        this.$router.replace({ query: { tab: 0 } })
      }
    },

    components: {
      ListDevices,
      ListDeviceTingBox,
    },
  }
</script>
